import {
  CurrencyStringCents,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'

const ns = 'Offerings.Details.form'

export const ContractEstimatedTotalMSRP = ({
  value,
  currency = 'USD',
}: {
  value: number
  currency?: string
}) => {
  return (
    <>
      <CurrencyStringCents currency={currency} value={value} />
      {' /'}
      <FormattedMessage id={`${ns}.headers.order`} />
    </>
  )
}
